import EditAccountForm from "./EditAccountForm.vue";
import Wishlist from "./Wishlist.vue";
import PurchaseCompleted from "./purchase-completed/PurchaseCompleted";
import Purchases from "./Purchases";

export default {
    "edit-account-form": EditAccountForm,
    wishlist: Wishlist,
    "purchase-completed": PurchaseCompleted,
    purchases: Purchases
};
